import React,{ useState, useContext } from 'react'
import { UserContext } from '../../contexts/userProvider'
import {
    LeftPanel,
    LogoSection,
    LoginForm,
    MobileFeatures,
    Footer
} from './Components'

const Login = () => {
    const { signIn, setAlert } = useContext(UserContext);
    const [login, setLogin] = useState({email: '', senha: ''})

    function handleEmailChange(event) {
        setLogin({...login, email: event.target.value})
    }
      
    function handlePasswordChange(event) {
        setLogin({...login, senha: event.target.value})
    }

    function logIn() {
        if(login.email === '' || login.senha === '') {
            setAlert({visible: true, title: 'Atenção!', placeholder: 'Para realizar o login, preencha todos os campos!', confirm: false, type: 'warning'})
        } else {
            signIn(login.email, login.senha)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        logIn();
    };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex">
        <LeftPanel />
        
        {/* Lado direito - Formulário de login */}
        <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
            <div className="w-full max-w-md">
                <LogoSection />
                
                <LoginForm
                    login={login}
                    onEmailChange={handleEmailChange}
                    onPasswordChange={handlePasswordChange}
                    onSubmit={handleSubmit}
                />
                
                <MobileFeatures />
                
                <Footer />
            </div>
        </div>
    </div>
  )
}

export default Login
 